const links = [
  {
    title: "Motorisation",
    desc: "Passez au volet électrique avec motorisation Somfy, Nice ou Simu. Confort et sécurité.",
    href: "/motorisation-somfy",
    icon: "ri-battery-line",
  },
  {
    title: "Réparation",
    desc: "Volet en panne ? Sangle cassée, moteur silencieux ou télécommande HS ? Nous réparons sur place.",
    href: "/reparation-volet-roulant",
    icon: "ri-tools-line",
  },
  {
    title: "Dépannage urgence",
    desc: "Volet bloqué ou coincé en urgence ? Intervention rapide à Strasbourg et dans le Bas-Rhin.",
    href: "/depannage-urgence",
    icon: "ri-alarm-warning-line",
  },
];

export default function Maillage() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Nos autres prestations
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {links.map((l) => (
            <a
              key={l.title}
              href={l.href}
              className="bg-white rounded-xl p-6 md:p-7 border border-brand-border hover:border-brand-cyan/40 transition-colors group"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-brand-cyan/10 mb-4">
                <i className={`${l.icon} text-brand-cyan text-lg`}></i>
              </div>
              <h3 className="text-brand-blue text-lg font-bold mb-1">{l.title}</h3>
              <p className="text-brand-text text-sm mb-4">{l.desc}</p>
              <span className="inline-flex items-center gap-1 text-brand-blue text-sm font-semibold group-hover:text-brand-cyan transition-colors group-hover:gap-2">
                En savoir plus
                <i className="ri-arrow-right-line text-sm transition-all"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}